export const now = (): string => new Date().toISOString()

export const day = (d: Date): string => `0${d.getUTCDate()}`.slice(-2)

export const month = (d: Date): string => `0${d.getUTCMonth() + 1}`.slice(-2)

export const year = (d: Date): string => `${d.getUTCFullYear()}`
